module.exports = __webpack_public_path__ + "img/pluto26.edc45a39.jpg";